import script from "./PersonalisationLandingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonalisationLandingPage.vue?vue&type=script&setup=true&lang=ts"

import "./PersonalisationLandingPage.vue?vue&type=style&index=0&id=49531638&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49531638"]])

export default __exports__